import { FC } from 'react';
import { Button, Stack } from '@mui/material';

import { LoadingButton } from '~components/atoms/custom/Button';
import { LocalizationTypography } from '~components/organisms/localization';

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
  canConfirm: boolean;
};

export const CardDeleteConfirmActions: FC<Props> = ({
  onCancel,
  onConfirm,
  isDeleting,
  canConfirm,
}) => {
  return (
    <Stack
      direction="row"
      sx={{
        py: 1.5,
        gap: 2,
      }}
    >
      <Button
        variant="outlined"
        sx={(theme) => ({
          border: `1px solid ${theme.palette.primary.main}`,
          color: theme.palette.primary.main,
          borderRadius: '100px',
        })}
        onClick={onCancel}
        disabled={isDeleting}
      >
        <LocalizationTypography
          textId="button.cancel"
          defaultText="Cancel"
          variant="Poppins/Subheading-sm"
        />
      </Button>

      <LoadingButton
        fullWidth={false}
        size="medium"
        isLoading={isDeleting}
        disabled={!canConfirm}
        onClick={onConfirm}
        sx={{ width: 'fit-content', borderRadius: '100px' }}
      >
        <LocalizationTypography
          textId="button.confirm"
          defaultText="Confirm"
          variant="Poppins/Subheading-sm"
        />
      </LoadingButton>
    </Stack>
  );
};
